import { createRef, useCallback, useState } from 'react';
const ref = createRef();

const UsePortal = () => {
    const [coords, setCoords] = useState({}); // takes current button coordinates

    const updateTooltipCoords = useCallback((el, offset) => {
        const rect = el.getBoundingClientRect();

        setCoords({
            left: rect.x - offset + rect.width,
            top: rect.y + window.scrollY + rect.height + 6,
        });
    }, []);
    return { coords, updateTooltipCoords, ref };
};

export default UsePortal;
